import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import {
  AddEstimateApplianceInput,
  AddEstimateApplianceMutation as AddEstimateApplianceMutationResult,
} from '@/gql/graphql';
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { hydrateEstimateCaches } from './hydrateEstimateCaches';

const AddEstimateApplianceMutation = graphql(`
  mutation AddEstimateAppliance($input: AddEstimateApplianceInput!) {
    addEstimateAppliance(input: $input) {
      ...EstimateBuilderEstimate
      preview {
        template
        context
        pendingSolarLayoutImage
      }
    }
  }
`);

const useAddEstimateAppliance = (args: {
  projectId: string;
  estimateId: string;
  options?: UseMutationOptions<
    AddEstimateApplianceMutationResult,
    Error,
    AddEstimateApplianceInput
  >;
}) => {
  const { projectId, estimateId } = args;
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = args.options ?? {};

  return useMutation<
    AddEstimateApplianceMutationResult,
    Error,
    AddEstimateApplianceInput
  >({
    mutationFn: (input) =>
      gqlClient.request(AddEstimateApplianceMutation, { input }),
    onSuccess: (data, variables, context) => {
      hydrateEstimateCaches(queryClient, {
        projectId,
        estimateId,
        estimate: data.addEstimateAppliance,
      });
      onSuccess?.(data, variables, context);
    },
    ...restOptions,
  });
};

export default useAddEstimateAppliance;
